import {INIT_URL,SET_SOCKET} from "../types";
import { lsGet } from '../../utils/hooks';

const INIT_STATE = {
  // token: "",
  // initURL: '',
  // authUser: "",
  token: lsGet('token') || "",
  initURL: '',
  authUser: lsGet('user') || "",
  socket: null,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {

    case INIT_URL: {
      return { ...state, initURL: action.payload };
    }

    case SET_SOCKET: {
      return { ...state, socket: action.payload };
    }

    case "DUMMY": {
      return { ...state, name: action.payload }
    }
    default:
      return state;
  }
}